import { Divider, styled } from '@mui/material';

export const StyledDivider = styled(Divider)<{ mb?: number }>`
  flex: 1;
  width: 100%;
  margin-bottom: ${({ mb }) => mb || 16}px;
`;
